import { t } from "i18next";
import React from "react";
import ReactDOM from "react-dom";
import OutsideClickHandler from "react-outside-click-handler";
import { useNavigate } from "react-router-dom";
const Message = () => {
  const navigate = useNavigate();
  return ReactDOM.createPortal(
    <app-popup-page
      _ngcontent-serverapp-c4268204220
      className="ng-tns-c4268204220-0 popup-page-wrapper active"
      _nghost-serverapp-c2790459173
    >
      <div
        _ngcontent-serverapp-c2790459173
        className="popup-page popup-page--active popup-page--align-top"
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__backdrop"
        />
        <OutsideClickHandler onOutsideClick={() => navigate(-1)}>

       
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__main popup-page-main popup-page-main--show"
        >
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page-main__header"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__title"
            >
              {t("Mailbox")}
            </div>
            <div
              onClick={() => navigate("/")}
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__close ng-star-inserted"
            />
          </div>
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page-main__container"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="content player-content"
            >
              <ng-component
                _nghost-serverapp-c2086224751
                className="ng-tns-c2086224751-43 ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c2086224751
                  className="tab-content tab-content-page ng-tns-c2086224751-43"
                >
                  <div
                    _ngcontent-serverapp-c2086224751
                    className="ng-tns-c2086224751-43 ng-trigger ng-trigger-tabPageTriggerAni"
                  >
                    <router-outlet
                      _ngcontent-serverapp-c2086224751
                      className="ng-tns-c2086224751-43"
                    />
                    <ng-component
                      _nghost-serverapp-c3145400398
                      className="ng-tns-c3145400398-44 ng-star-inserted"
                     
                    >
                      <div
                        _ngcontent-serverapp-c3145400398
                        className="inner-wrap inbox-list ng-tns-c3145400398-44 ng-star-inserted"
                      >
                        <div
                          _ngcontent-serverapp-c3145400398
                          className="inner-box ng-tns-c3145400398-44"
                        >
                          <div
                            _ngcontent-serverapp-c3145400398
                            className="inbox-list__editor editor ng-tns-c3145400398-44 ng-star-inserted"
                      
                          >
                            <div
                              _ngcontent-serverapp-c3145400398
                              className="editor__btn ng-tns-c3145400398-44"
                              style={{
                                display: "block",
                                "mask-image":
                                  'url("/assets/Other/icon-editor.svg")',
                              }}
                            />
                          </div>

                          <app-waterfall-scroll
                            _ngcontent-serverapp-c3145400398
                            _nghost-serverapp-c302379289
                            className="ng-tns-c3145400398-44 ng-star-inserted"
                            style={{}}
                          >
                            <div
                              _ngcontent-serverapp-c3145400398
                              className="list-group ng-tns-c3145400398-44 ng-star-inserted"
                            >
                              <div
                                _ngcontent-serverapp-c3145400398
                                className="date-title ng-tns-c3145400398-44"
                              >
                                <div
                                  _ngcontent-serverapp-c3145400398
                                  className="date ng-tns-c3145400398-44"
                                >
                                  <i
                                    _ngcontent-serverapp-c3145400398
                                    className="ng-tns-c3145400398-44"
                                    style={{
                                      "mask-image":
                                        'url("/assets/Other/icon-calendar-type02.svg")',
                                    }}
                                  />
                                  2025/08/27
                                </div>
                                <div
                                  _ngcontent-serverapp-c3145400398
                                  className="time-zone ng-tns-c3145400398-44"
                                >
                                  GMT+5.5
                                </div>
                              </div>
                              <div
                                _ngcontent-serverapp-c3145400398
                                className="list-content ng-tns-c3145400398-44"
                              >
                                <ul
                                  _ngcontent-serverapp-c3145400398
                                  className="ng-tns-c3145400398-44 ng-star-inserted"
                                >
                                  <li
                                    _ngcontent-serverapp-c3145400398
                                    className="message-item ng-tns-c3145400398-44"
                                    idx={1743823350}
                                  >
                                    <div
                                      _ngcontent-serverapp-c3145400398
                                      className="list-field chose-btn ng-tns-c3145400398-44"
                                    />
                                    <div
                                      _ngcontent-serverapp-c3145400398
                                      className="list-field icon ng-tns-c3145400398-44"
                                    >
                                      <img
                                        _ngcontent-serverapp-c3145400398
                                        alt="icon-speaker"
                                        className="ng-tns-c3145400398-44"
                                        src="/assets/Other/icon-speaker.svg"
                                        loading="lazy"
                                      />
                                    </div>
                                    <div
                                      _ngcontent-serverapp-c3145400398
                                      className="list-field content-wrap ng-tns-c3145400398-44"
                                    >
                                      <div
                                        _ngcontent-serverapp-c3145400398
                                        className="title ng-tns-c3145400398-44"
                                      >
                                        <span
                                          _ngcontent-serverapp-c3145400398
                                          className="ng-tns-c3145400398-44"
                                        >
                                          Sign up success.
                                        </span>
                                        <div
                                          _ngcontent-serverapp-c3145400398
                                          className="msg-time ng-tns-c3145400398-44"
                                        >
                                          11:39:31
                                        </div>
                                      </div>
                                      <div
                                        _ngcontent-serverapp-c3145400398
                                        className="text ng-tns-c3145400398-44"
                                      >
                                        Congratulations, you have successfully
                                        signed up! Get ready to experience the
                                        excitement of our platform.
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>

                            <div
                              _ngcontent-serverapp-c3145400398
                              className="prompt ng-tns-c3145400398-44 ng-star-inserted"
                              style={{ "margin-top": "20px" }}
                            >
                              －end of page－
                            </div>

                            <div
                              _ngcontent-serverapp-c302379289
                              style={{ height: "10px", visibility: "hidden" }}
                            >
                              {" "}
                              anchor{" "}
                            </div>
                          </app-waterfall-scroll>
                        </div>
                      </div>
                      <div
                        _ngcontent-serverapp-c3145400398
                        className="pop-wrap pop-editor ng-tns-c3145400398-44 ng-star-inserted"
                      >
                        <ul
                          _ngcontent-serverapp-c3145400398
                          className="editor-menu ng-tns-c3145400398-44"
                        >
                          <li
                            _ngcontent-serverapp-c3145400398
                            className="ng-tns-c3145400398-44"
                          >
                            Edit
                          </li>
                          <li
                            _ngcontent-serverapp-c3145400398
                            className="ng-tns-c3145400398-44"
                          >
                            Read All
                          </li>
                          <li
                            _ngcontent-serverapp-c3145400398
                            className="ng-tns-c3145400398-44"
                          >
                            Cancel
                          </li>
                        </ul>
                        <ul
                          _ngcontent-serverapp-c3145400398
                          className="editor-check ng-tns-c3145400398-44"
                        >
                          <li
                            _ngcontent-serverapp-c3145400398
                            className="ng-tns-c3145400398-44"
                          >
                            Mark
                          </li>
                          <li
                            _ngcontent-serverapp-c3145400398
                            className="ng-tns-c3145400398-44"
                          >
                            Delete
                          </li>
                        </ul>
                      </div>
                    </ng-component>
                  </div>
                </div>
              </ng-component>
            </div>
          </div>
        </div> </OutsideClickHandler>
      </div>
    </app-popup-page>,
    document.getElementById("overlay")
  );
};

export default Message;
